module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "dm01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle0",
    staticStyle: {
      "text-indent": "0%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("From the gates of the papal palace in Avignon issued a rider at a pace to make the sparks fly. With a leather bag strapped across his chest under the billowing folds of a cloak, he rode furiously northwards. Unencumbered by page or squire, he reached the court of the Duke of Burgundy in his castle at Dijon in less than a fortnight. When he arrived, the duke, uncle of the young king and controller of France, was preparing for war. Several meetings in the privacy of the ducal chambers took place before the rider set out again. This time he travelled in the company of the duke’s own army, augmented by those of Berry and Bourbon and all the foremost lords of France with their seigneurs and squires. So great was the cavalcade that woodcutters had to be sent on ahead to fell trees in order to widen the line of march. Impervious to the sullen populace, who kept their shutters closed and refused supplies, the messenger accompanied the army as far as the River Lys at the border with Flanders. There, in the guise of a Flemish merchant, he left them en route to their bloody victory at Roosebeeke, and, taking a detour around the battlefront, made for the port of Damme.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10b0c159","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781429964555_dm01.vue
// module id = 72
// module chunks = 0